<template>
  <DataTable
    :value="listDataService"
    :lazy="true"
    class="p-datatable-responsive"
    selectionMode="single"
    data-key="id"
    @page="onPage($event)"
    :paginator="pagination"
    :totalRecords="totalRecords"
    :rows="paginationRows"
    :loading="loading"
    :first="firstRecordIndex"
    :scrollable="scrollHeight !== ''"
    :scrollHeight="scrollHeight"
    :autoLayout="true"
    filterMatchMode="startsWith"
    :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
    :currentPageReportTemplate="$constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM + ' {totalRecords}'"
    :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
  >
    <Column
      v-for="c in model.getDisplayFields()"
      :key="c.key"
      :field="getField(c)"
      :header="getLabel(c)"
      :ref="getField(c)"
      :filterMatchMode="getFilterMatch(c)"
      :sortable="getSortable(c)"
      :bodyClass="c.class ? 'txt-' + c.class : ''"
      :bodyStyle="getHeaderStyle(c)"
      :headerStyle="getHeaderStyle(c)"
      :headerClass="c.class ? 'txt-' + c.class : ''"
    >
      <template #body="slotProps">
        <div v-if="getType(c) == 'Boolean'" v-html="getData(c, slotProps.data)" :style="c.style ? c.style : ''"></div>
        <div v-else>
          <div v-if="c.custom">
            <div v-if="c.custom == 'SelectionText'" v-html="callbackDataSelect(c, slotProps.data)"></div>
          </div>
          <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
        </div>
      </template>
      <template v-if="c.filter" #filter>
        <InputText
          v-if="c.filter.type == 'input'"
          type="text"
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :placeholder="getFilterPlaceHolder(c)"
          @keyup="onFilter($event, c.filter.type, c.key)"
        />
        <Dropdown
          :key="countDropdown"
          v-if="c.filter.type == 'select'"
          v-model="filters[getField(c)]"
          :options="getFilterOptions(c.key)"
          :optionLabel="c.filter.optionLabel"
          :optionValue="c.filter.optionKey"
          :placeholder="getFilterPlaceHolder(c)"
          class="p-column-filter"
          :showClear="true"
          appendTo="body"
          @change="onFilter($event, c.filter.type, c.key)"
        />
        <Calendar
          v-if="c.filter.type == 'DateRange'"
          :showOnFocus="false"
          :monthNavigator="true"
          :yearNavigator="true"
          :yearRange="yearRange"
          dateFormat="yy-mm-dd"
          :placeholder="getFilterPlaceHolder(c)"
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :showIcon="true"
          selectionMode="range"
          appendTo="body"
          :showClear="true"
          :showButtonBar="true"
          @clear-click="onFilter($event, c.filter.type, c.key)"
          @date-select="onFilter($event, c.filter.type, c.key)"
          :manualInput="false"
          style="width: 200px"
        />
      </template>
    </Column>
    <Column v-if="actions" headerStyle="width: 10em; text-align: center" bodyStyle="width: 10em; text-align: center">
      <template #body="slotProps">
        <Button
          v-for="(a, k) in actions.rows(slotProps.data)"
          :key="k"
          type="button"
          :icon="getIcon(a.icon)"
          :class="getClass(a.name)"
          :disabled="getDisabled(a.disabled)"
          style="margin: 2px"
          v-on:click="actionsClicked(k, a, slotProps)"
        ></Button>
      </template>
      <template #header="slotProps">
        <Button v-if="actions.header" type="button" :icon="getIcon(actions.header.icon)" :class="getClass(actions.header.name)" v-on:click="actionsClicked(actions.header.name, actions.header, slotProps)"></Button>
      </template>
    </Column>
    <template #empty>
      <div class="text-center">{{ $t("datatable.empty") }}</div>
    </template>
    <template #loading>
      <div class="text-center">{{ $t("datatable.loading") }}</div>
    </template>
  </DataTable>
</template>

<script>
import moment from "moment-timezone";
import ApiRepository from "@/core/ApiRepository";

export default {
  props: {
    model: Object,
    tableData: Array,
    getFilterOptions: Function,
    actions: Object,
    options: Array,
    whereKeyList: Object,
    company: Object,
    company_id: String,
  },
  data() {
    return {
      filters: {},
      countDropdown: 0,
      pagination: true,
      paginationRows: this.$constants.LIST_OPTION_COMMON.PAGINATION_ROWS_DEFAULT,
      scrollHeight: "",
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      first: 0,
      totalRecords: 0,
      test: null,
      listDataService: null,
      filtersCustom: {},
      lazyParams: {},
      page_transaction: null,
      firstRecordIndex: 0,
      yearRange: "2022:2300",
      time_zone_local: moment.tz.guess(true),
    };
  },
  async created() {
    var year = new Date().getFullYear();
    this.yearRange = "2022:" + (year + 100);
    this.test = this.tableData;
  },
  mounted() {
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (!this.$commonFuction.isEmpty(this.$route.query) && !this.$commonFuction.isEmpty(this.$route.query.page_transaction)) {
      this.page_transaction = this.$route.query.page_transaction;
      this.lazyParams = localStorage.getItem(this.page_transaction) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
      this.firstRecordIndex = this.lazyParams.first;
    }
    this.loading = false;
    this.countDropdown++;
    this.onLazyEvent();
  },
  methods: {
    getLabel(col) {
      return col.label ? col.label : col.name;
    },
    getType(col) {
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          return "Input";
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      return style;
    },
    getData(col, row) {
      if (col.type == "Datetime" && row[col.key]) {
        return moment.tz(row[col.key], this.time_zone_local).format("DD/MM/yyyy HH:mm");
      }
      if (col.type == "Boolean") {
        return row[col.key] ? '<i class="pi pi-check success bold"></i>' : '<i class="pi pi-times danger bold"></i>';
      }
      return row[col.key];
    },
    getFilterMatch(col) {
      return col.filter && col.filter.match ? col.filter.match : "startWith";
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) return col.filter.placeHolder;
      if (col.filter.type == "select") return "Chọn";
      if (col.filter.type == "input") return "Nhập";
      return "";
    },
    getSortable(col) {
      return col.sortable && col.sortable == true;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      this.$emit("action-click", {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData,
        lazyParams: this.lazyParams,
      });
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
      }
    },
    callbackDataSelect(c, data) {
      var text = "";
      if (c.key == "active") {
        text = data.active
          ? '<div style="text-align: center;"><i class="fa fa-solid fa-check" style="color: #00973D;"/></div>'
          : '<div style="text-align: center;"><i class="fa fa-solid fa-times" style="color: #E95D57;"/></div>';
      }
      return text;
    },
    async dataList(lazyParams) {
      var filters = lazyParams.filters;
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if (type_login != this.$constants.TYPE_USER.SUPPER_ADMIN) {
        company_id = this.$store.getters.company_id ?? null;
      }
      var listData = [];
      var total = 0;
      var token = this.$store.getters.token ? this.$store.getters.token : null;
      if (token && company_id) {
        const headers = {
          Authorization: "Bearer " + token,
        };
        var that = this;
        await ApiRepository.post("/_api/zone/list", { filters, limit: lazyParams.rows, offset: lazyParams.first, company_id: company_id }, { headers })
          .then(function (response) {
            var data = response.data.data;
            listData = data.zone;
            total = data.count;
          })
          .catch((err) => {
            that.$toast.add({ severity: "error", summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG, detail: err, life: 3000 });
          });
      }
      return { listData, total };
    },
    async onLazyEvent() {
      this.lazyParams.filters = this.filtersCustom;
      this.loading = true;
      var that = this;
      await this.dataList(this.lazyParams).then(async (data) => {
        if (data.listData.length < 1) {
          that.listDataService = data.listData;
          that.totalRecords = data.total;
          that.loading = false;
        }
        var stt = this.lazyParams.first;
        for (var i = 0; i < data.listData.length; i++) {
          stt++;
          data.listData[i].stt = stt;
        }
        that.listDataService = data.listData;
        that.totalRecords = data.total;
        that.loading = false;
      });
    },
    onPage(event) {
      this.lazyParams = event;
      this.onLazyEvent();
    },
    async onFilter(event, type_input, key) {
      this.tableData = this.test;
      if (type_input == "DateRange" && this.filters[key] !== null && this.filters[key][1] == null) {
        return false;
      }
      var filter = await this.$CoreService.convertFilter(type_input, key, this.filters);
      this.filtersCustom[key] = filter?.value;
      this.lazyParams.first = 0;
      await this.onLazyEvent();
    },
  },
};
</script>

<style lang="scss">
.p-paginator-bottom {
  padding: 0 !important;
}
.p-button-label-o {
  color: white;
}
.txt-required {
  color: red;
}
</style>
